import Dashboard from './dashboard/index';

function Home() {
    return (
        <Dashboard />
    );
}
export default Home;